import React from 'react';
import {
	Box,
	Heading,
	Text,
	Button,
	HStack,
	Flex,
	Badge,
	useColorModeValue,
} from '@chakra-ui/react';
import { FaCog, FaUser, FaThLarge } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { useAuthenticatedUserInfo } from '../../../services/Contexts/AuthenticatedUserInfoContext';

const getGreeting = () => {
	const hour = new Date().getHours();
	if (hour < 12) return 'Good morning';
	if (hour < 18) return 'Good afternoon';
	return 'Good evening';
};

const DashboardHeader = ({ company, user }) => {
	const navigate = useNavigate();
	const { userId } = useAuthenticatedUserInfo();
	const cardBg = useColorModeValue('white', 'gray.800');
	const cardBorder = useColorModeValue('gray.200', 'gray.600');
	const subtitleColor = useColorModeValue('gray.500', 'gray.400');

	const firstName = user?.firstName || 'there';

	return (
		<Box
			bg={cardBg}
			border='1px solid'
			borderColor={cardBorder}
			borderRadius='2xl'
			p={{ base: 5, md: 6 }}
			boxShadow='sm'>
			<Flex
				direction={{ base: 'column', lg: 'row' }}
				justify='space-between'
				align={{ lg: 'center' }}
				gap={4}>
				<Box>
					<Text fontSize='sm' color={subtitleColor} mb={1}>
					<span style={{ fontSize: '25px' }}>👋</span> {getGreeting()}, {firstName}
					</Text>
					<Heading size='lg' color='gray.800'>
						{company?.name || 'Company workspace'}
					</Heading>
					<Text color={subtitleColor} mt={2} fontSize='sm'>
						{company?.companySlogan ||
							'Your campaigns, projects, leads, and team in one place.'}
					</Text>
					<HStack mt={3} spacing={2} flexWrap='wrap'>
						{user?.role && (
							<Badge colorScheme='teal' borderRadius='full' px={3}>
								{user.role}
							</Badge>
						)}
						{company?.emailAddress && (
							<Badge variant='outline' colorScheme='gray' borderRadius='full' px={3}>
								{company.emailAddress}
							</Badge>
						)}
					</HStack>
				</Box>

				<HStack spacing={2} flexWrap='wrap'>
					<Button
						leftIcon={<FaThLarge />}
						variant='outline'
						colorScheme='teal'
						onClick={() => navigate('/todos-and-tasks')}>
						My workspace
					</Button>
					<Button
						leftIcon={<FaUser />}
						variant='outline'
						onClick={() => navigate(`/employee/view/${userId}`)}>
						My profile
					</Button>
					<Button
						leftIcon={<FaCog />}
						variant='ghost'
						onClick={() => navigate('/settings?section=branding')}>
						Settings
					</Button>
				</HStack>
			</Flex>
		</Box>
	);
};

export default DashboardHeader;
